module.exports = __webpack_public_path__ + "static/media/avatar-11.70456284.svg";